import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-exchange-token',
  templateUrl: './exchange-token.component.html',
  styleUrls: ['./exchange-token.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ExchangeTokenComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
  ) { }

  ngOnInit(): void {
    const self = this;
    self.route.queryParams.subscribe((o) => {
      if (o && o["token"]) {
        this.exchangeToken(o['token']).then(e => {
          if (e && e.success === true) {
            // this.sessionService.setSessionStorage('access_token', e['accessToken'].toString());
            localStorage.setItem('access_token', e.accessToken.toString());
            sessionStorage.setItem('userName', e.userName.toString());
            // localStorage.setItem("cookie",)
            self.router.navigateByUrl(e.redirectUrl);
          } else {
            self.router.navigateByUrl('/');
          }
        });
      }
    });
  }

  async exchangeToken(exchangeToken: string) {
    const apiUrl = `/auth/exchange/token`;
    const result = await firstValueFrom(this.http.post<{success:boolean,accessToken:string,redirectUrl:string, userName: string}>(apiUrl, { token: encodeURIComponent(exchangeToken) }));
    return result;
  }

}
